import React from 'react';
export function Header() {
  return <header className="w-full py-6 px-4 md:px-8" data-id="element-7">
      <div className="container mx-auto flex justify-center md:justify-start" data-id="element-8">
        <div className="text-5xl font-bold text-[#133863]" data-id="element-9">Alcre</div>
      </div>
    </header>;
}